import React from 'react';

import { ADD_RECORD_CLOSE_LABEL } from 'constants/uiConstants';

import FlyoutHeader from './FlyoutHeader';

interface InlineAddPanelProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Frame for an Add form shown inline under a plan field (OP-2498): a title
 * with a close button, then the form. Escape closes it; closing sends nothing.
 */
const InlineAddPanel: React.FC<InlineAddPanelProps> = ({
  title,
  onClose,
  children,
}) => (
  <div
    role="group"
    aria-label={title}
    className="flex flex-col overflow-hidden rounded-lg border border-gray-bright bg-white"
    onKeyDown={(event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onClose();
      }
    }}
  >
    <FlyoutHeader
      title={title}
      closeLabel={ADD_RECORD_CLOSE_LABEL}
      onClose={onClose}
    />
    {children}
  </div>
);

export default InlineAddPanel;
